import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconRocket_16 = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 16 16"
    data-fill-none
  >
    <path
      d="M6.55012 5.52564C4.87386 4.38195 2.13854 4.63844 1.53388 6.1077C1.38137 6.47827 1.62296 6.86485 1.96621 7.07163L4.68659 8.71041"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4748 9.45142C11.6186 11.1278 11.363 13.8634 9.89278 14.4678C9.52216 14.6201 9.1356 14.3786 8.92882 14.0353L7.29004 11.3149"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.68652 8.70217L7.29941 11.3151C9.38972 10.0628 11.766 8.85007 12.8505 7.72604C14.5426 6.03402 14.3072 3.89091 14.0442 2.82686C13.9373 2.39441 13.6072 2.06427 13.1747 1.95738C12.1107 1.69438 9.96756 1.45901 8.27554 3.15102C7.15151 4.23562 5.92888 6.62172 4.68652 8.70217Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.78178 12.466C4.89208 13.3557 3.23289 12.9244 3.23289 12.9244C3.23289 12.9244 2.86802 11.1989 3.69147 10.3757"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
IconRocket_16.displayName = 'IconRocket_16';
